export default function FlatList(props){
    if (props.data.length > 0) {
        return (
            props.data.map((item,index) => props.renderItem(item,index))
        )
    } else {
        return props.renderEmpty;
    }
}